var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import { DiagramConsts } from '../diagram-consts';
import { ConditionalEnableNodeElement } from './base/conditional-enable-node-element';
import { GraphService } from '../../../../shared/gallery/graph.service';
var ToggleViewElement = /** @class */ (function (_super) {
    __extends(ToggleViewElement, _super);
    function ToggleViewElement(injector) {
        var _this = _super.call(this, injector) || this;
        _this.graphService = injector.get(GraphService);
        return _this;
    }
    ToggleViewElement.prototype.compile = function (model, data, svg) {
        model['version'] = 6;
        model['angle'] = data.angle;
        model['category'] = 'ViewOperation';
        model['useSecurity'] = data.useSecurity;
        model['isRecordOperation'] = data.isRecordOperation;
        if (data.isRecordOperation) {
            model['operationDescription'] = data.operationDescription;
        }
        model['enablePassword'] = data.enablePassword;
        model['size'] = this.sizeService.parse(data.size);
        model['operationType'] = data.actionButtonType;
        model['viewId'] = data.viewId;
        model['viewIndex'] = data.viewIndex;
        model['useGraph'] = data.useGraph;
        model['graphSetting'] = data.graphSetting;
        model['label'] = data.label;
        model['isAwaysDisplay'] = data.isAwaysDisplay;
        model['isDisplayControl'] = data.displayLogicEnabled;
        model['conditionItems'] = data.conditionItems;
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
        // 清除编辑器的虚线及下划线
        svg.find('path').remove();
        if (data.label && data.label.font && data.label.font.isUnderline) {
            svg.find('text').attr('text-decoration', 'underline');
        }
        svg.find('image').remove();
    };
    ToggleViewElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/toggle-view.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l('ViewOperationButton'),
            editable: false
        }));
    };
    ToggleViewElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Auto', {
            rotatable: true,
            resizable: true, resizeObjectName: 'SHAPE',
            locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('rotatable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, 'Rectangle', {
            name: 'SHAPE',
            fill: 'transparent',
            stroke: 'transparent',
            strokeWidth: 0.5,
            strokeDashArray: [4, 4]
        }, new go.Binding('stroke', 'useGraph', function (useGraph) { return useGraph ? 'transparent' : 'gray'; }), new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify)), $(go.Picture, { sourceCrossOrigin: function (pict) { return 'anonymous'; } }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('source', 'graphSetting', function (setting, _) { return _this.graphService.getCustomStyleGraphUrl(setting); }), new go.Binding('visible', 'useGraph')), $(go.TextBlock, { editable: false, alignment: go.Spot.Center, verticalAlignment: go.Spot.Center }, new go.Binding('font', 'label', function (label) { return label.font.fontStyle + ',msyh'; }), new go.Binding('isUnderline', 'label', function (label) { return label.font.isUnderline; }), new go.Binding('stroke', 'label', function (label) { return label.font.color; }), new go.Binding('text', 'label', function (label) { return label.content; })));
    };
    ToggleViewElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.toggleViewKey;
    };
    return ToggleViewElement;
}(ConditionalEnableNodeElement));
export { ToggleViewElement };
